import { createFileRoute } from '@tanstack/react-router';
import { OwnerCalendar } from '@/pet/src/components/owner/OwnerCalendar';

export const Route = createFileRoute('/dashboard/calendar')({
  component: PetsoCalendar,
});

function PetsoCalendar() {
  return <OwnerCalendar />;
}
